(() => {
  const root = document.documentElement;
  const desktop = window.matchMedia('(min-width: 769px)');
  let dispose;

  function init() {
    if (dispose) dispose();
    const header = document.querySelector('#SiteHeader');
    const search = header?.querySelector('.header-item--search > .predictive_screen_container');
    const cart = header?.querySelector('#HeaderCartTrigger');
    const boundary = document.querySelector('#shopify-section-header-menu-desktop') || header;
    if (!search || !cart || !boundary) return;

    let observer;
    let frame;
    const floatingClass = 'cz-desktop-search-floating';
    const focusedClass = 'cz-desktop-search-focused';

    function update() {
      frame = null;
      const floating = desktop.matches && boundary.getBoundingClientRect().bottom <= 0;
      root.classList.toggle(floatingClass, floating);
      if (!floating) root.classList.remove(focusedClass);
      else if (search.contains(document.activeElement)) root.classList.add(focusedClass);
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    function focus(event) {
      if (!root.classList.contains(floatingClass)) return;
      const inSearch = search.contains(event.target);
      const inSuggestions = event.target.closest?.('#snize-instant-search-results');
      root.classList.toggle(focusedClass, Boolean(inSearch || inSuggestions));
    }

    function breakpoint() {
      if (observer) observer.disconnect();
      window.removeEventListener('scroll', schedule);
      if (desktop.matches) {
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(update, { threshold: 0 });
          observer.observe(boundary);
        } else {
          window.addEventListener('scroll', schedule, { passive: true });
        }
      }
      update();
    }

    document.addEventListener('focusin', focus);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', update);
    desktop.addEventListener('change', breakpoint);
    breakpoint();

    dispose = () => {
      observer?.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      document.removeEventListener('focusin', focus);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('pageshow', update);
      desktop.removeEventListener('change', breakpoint);
      root.classList.remove(floatingClass, focusedClass);
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
